export default import.meta.ROLLUP_FILE_URL_Dp4$LvWw;